export default __webpack_public_path__ + "static/media/Setting_Phantasia.446f6a9b.png";